import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
} from '@mui/material';
import { SlideAIModelModalRow } from 'components/AITools/components/SlideAIModelModalRow';
import { useAIModelModalStyles } from 'components/AITools/constants/styles';
import { COMPUTE_COST_LABEL } from 'components/pages/AppLibrary/constants';
import { useSelector } from 'react-redux';
import { isStaffSelector } from 'store/slices/userDetailsSlice';

export const SlideAIModalPaymentInfo = ({
  slidesCount,
  isAllSlidesAvailable,
  handleConfirmPayment,
  handleUnsafeConfirmPayment,
  model,
  isConfirming,
  balance,
}) => {
  const { classes } = useAIModelModalStyles();
  const isStaff = useSelector(isStaffSelector);
  const { toolDetails } = model;
  const price = toolDetails[0].toolDetail.find(
    (detail) => detail.label === COMPUTE_COST_LABEL,
  ).value;

  const numericFixedPrice = (+price).toFixed?.(2);
  const isPriceNumeric = numericFixedPrice && numericFixedPrice !== 'NaN';
  const totalCost = isPriceNumeric
    ? `$ ${(slidesCount * price).toFixed(2)}`
    : price;
  const slidesCost = isPriceNumeric ? `$ ${numericFixedPrice}` : '-';
  const amountInWallet = `$ ${balance.toFixed(2)}`;
  const showStaffOverride = isStaff && !isAllSlidesAvailable;

  return (
    <Accordion className={classes.infoSection} expanded disableGutters>
      <AccordionSummary className={classes.accordionSummary}>
        <Typography className={classes.title}>Payment Confirmation</Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        <Box width="50%">
          <SlideAIModelModalRow
            field="TOTAL NO OF COMPATIBLE SLIDES"
            value={slidesCount}
            pt={2}
          />
          <SlideAIModelModalRow
            field="Compute Cost per Slide"
            value={slidesCost}
          />
          <SlideAIModelModalRow field="Total Cost" value={totalCost} />
          <SlideAIModelModalRow
            field="Amount in Wallet"
            value={amountInWallet}
          />
          <Button
            variant="contained"
            className={classes.confirmButton}
            onClick={handleConfirmPayment}
            disabled={!isPriceNumeric || isConfirming || !slidesCount}
          >
            {/* @TODO: Uncomment this line after editing updates */}
            {/* {withIssues ? 'PROCEED ANYWAY' : 'Confirm Payment'} */}
            Confirm Payment
          </Button>
          {showStaffOverride && (
            <Button
              color="error"
              variant="contained"
              className={classes.confirmButton}
              onClick={handleUnsafeConfirmPayment}
              disabled={isConfirming}
            >
              HistoWiz Admin Override
            </Button>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
